module.exports = __webpack_public_path__ + "resources/img/img_datahunt4_jp.f3204606ec426e1e0574007ad26edbdd.png";